module.exports = __webpack_public_path__ + "static/media/30.1d2eaff2.png";